import { useState, useEffect } from "react";
import { Button, IconButton, Stack, Typography } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";

const IncrementDecrement = (props) => {
  const [value, setValue] = useState(props.value);
  const buttonStyle = { minWidth: 50, height: 50, outline: 1, borderRadius: 0, backgroundColor: "#1976d2"};
  const labelStyle = {
    width: "60px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "30px",
    fontWeight: "bold",
    color: "#000"
  };

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleIncrement = () => {
    props.onChange(value + 1);
    setValue(value + 1);
  };

  const handleDecrement = () => {
    if (value > 0) {
      props.onChange(value - 1);
      setValue(value - 1);
    }
  };

  return (
    <Stack direction="row" sx={{border: 1}}>
      <IconButton onClick={handleDecrement} sx={buttonStyle} disableRipple>
        <Remove sx={{color: "#fff"}} />
      </IconButton>
      <Typography
        sx={labelStyle}
      >
        {value}
      </Typography>
      <IconButton onClick={handleIncrement} sx={buttonStyle} disableRipple>
        <Add sx={{color: "#fff"}} />
      </IconButton>
    </Stack>
  );
};

export default IncrementDecrement;
